import React from 'react';
import cn from 'classnames';
import {CoachingDirection, RepProfileTab} from '@store/coaching-plans';
import {RepSubtab} from './RepSubtab';

interface RepTabProps {
  activeTab: RepProfileTab;
  tab: RepProfileTab;
  icon: any;
  label: string;
  subtabs?: RepSubtab[];
  direction: CoachingDirection;
  onSelect: (tab: RepProfileTab) => void;
}

export const RepTab: React.FC<RepTabProps> = ({
  activeTab,
  direction,
  icon: Icon,
  label,
  onSelect,
  subtabs,
  tab,
}) => {
  return (
    <div
      className={cn('link-container', 'dashv2-rep', {
        'child-active': tab === activeTab,
      })}>
      {/* // TODO: a must be replaced with button and eslint ignore must be removed*/}
      {/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */}
      <a href="javascript:;" onClick={() => onSelect(tab)} className="link">
        <Icon />
        {label}
      </a>
      {subtabs && (
        <div className="menu sub-menu">
          {subtabs.map((subtab, i) => (
            <div key={i}>
              <a
                // TODO: a must be replaced with button and eslint ignore must be removed
                /* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
                href="javascript:;"
                onClick={e => {
                  e.stopPropagation();
                  subtab.onClick('review');
                }}
                className={cn('link', subtab.active(direction))}>
                {subtab.label}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
